import React from 'react';
import { Alert } from 'reactstrap';

const PaymentDeferralBadge = ({ targetMemberName, questionsFee }) => {
    return (
        <Alert color="info" className="mt-3 mb-3" style={{ borderLeft: '4px solid #17a2b8' }}>
            <div className="d-flex align-items-start">
                <i className="fas fa-info-circle fa-2x text-info mr-3 mt-1"></i>
                <div className="flex-grow-1">
                    <h5 className="alert-heading mb-2">
                        <i className="fas fa-clock mr-2"></i>
                        Payment Will Be Deferred
                    </h5>
                    <p className="mb-2">
                        <strong>{targetMemberName}</strong> will be registered for this event.
                        The payment of <strong>${questionsFee.toFixed(2)}</strong> will be deferred to the member.
                    </p>

                    <hr className="my-2" />
                    <p className="mb-0">
                        <i className="fas fa-envelope text-success mr-2"></i>
                        <strong>Email Notification:</strong> {targetMemberName} will receive an email with payment instructions to complete payment via "My Registrations".
                    </p>
                </div>
            </div>
        </Alert>
    );
};

export default PaymentDeferralBadge;
